import { useEffect } from 'react';
import { WelcomeHeader, WelcomeFooter } from '../welcome/WelcomeNavigation';
import { WelcomeHero } from '../welcome/WelcomeHero';
import { FeatureShowcase } from '../welcome/FeatureShowcase';
import { ClinicalSection, PatientSection, OperationsSection } from '../welcome/CareSections';
import { OfflineSection } from '../welcome/OfflineSection';
import { GhanaSection } from '../welcome/GhanaSection';
import { WhatsAppButton } from '../welcome/WhatsAppButton';
import { InteractiveDemos } from '../welcome/InteractiveDemos';
import { RoiCalculator } from '../welcome/RoiCalculator';
import { WelcomeFaq } from '../welcome/WelcomeFaq';
import { DemoRequest } from '../welcome/DemoRequest';
import '../welcome/welcome.css';

export default function WelcomePage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'DutiLyne — More care. Less complexity.';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <div className="wl" data-testid="welcome-page">
      <a className="wl-skip" href="#welcome-main" data-testid="welcome-skip-link">Skip to content</a>
      <WelcomeHeader />
      <main id="welcome-main" tabIndex={-1}>
        <WelcomeHero />
        <FeatureShowcase />
        <ClinicalSection />
        <OfflineSection />
        <GhanaSection />
        <PatientSection />
        <OperationsSection />
        <InteractiveDemos />
        <RoiCalculator />
        <WelcomeFaq />
        <DemoRequest />
      </main>
      <WelcomeFooter />
      <WhatsAppButton />
    </div>
  );
}